module.exports = __webpack_public_path__ + "img/map.d6614606.png";